import React from 'react';

import { AppBar, useMediaQuery, useTheme } from '@mui/material';
import cx from 'classnames';

import { navigationInsetShadow } from 'c-wrapper/constants';

import { useIsMobileView } from 'c-hooks';
import { makeStyles } from '@mui/styles';
import AppBarToolbar from './AppBarToolbar';
import ResetDrawerOverlay from './ResetDrawerOverlay';

const useStyles = makeStyles(theme => ({
    appBar: {
        width: '100%',
        background: theme.palette?.custom?.navigationBgColor ?? theme.palette.background.paper,
        // the AppBar would otherwise inherit primary.contrastText, which is dark in dark mode
        ...(theme.palette.mode === 'dark' && { color: theme.palette.text.primary }),
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    customDrawerStyling: {
        background: theme.palette?.custom?.navigationBgColor ?? theme.palette.background.paper,
    },
}));

const PaperProps = {
    sx: {
        boxShadow: navigationInsetShadow,
        border: 'none',
    },
};

const TopAppBar = () => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isDrawerOverlay = useIsMobileView();

    return (
        <>
            <ResetDrawerOverlay />
            <AppBar
                position="sticky"
                className={cx(classes.appBar)}
                sx={{
                    boxShadow: 1,
                }}
            >
                <AppBarToolbar mobileDrawer={isDrawerOverlay} />
            </AppBar>
        </>
    );
};

export default TopAppBar;
